import React from "react";

export default class SliderArrows extends React.Component {

	render() {
		return <div className={"slider-arrows "+this.props.color}>
            <div className="arrow next" onClick={this.props.goToNextSlide}></div>
			<div className="arrow previous" onClick={this.props.goToPrevSlide}></div>
		</div>
	}

}
